import { chatService } from 'config/api';

import actionTypes from './actionTypes';

export const initializeChat = (associatePin, UCAProfileId) => async (dispatch) => {
  dispatch({ type: actionTypes.INITIALIZE_CHAT_LOADING });

  try {
    const res = await chatService.post('', { profileId: UCAProfileId, associatePin });
    dispatch({
      type: actionTypes.INITIALIZE_CHAT_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: actionTypes.INITIALIZE_CHAT_ERROR,
      payload: error,
    });
  }
};

export const getChatToken = () => async (dispatch) => {
  dispatch({ type: actionTypes.GET_CHAT_TOKEN_LOADING });

  try {
    const res = await chatService.get('/auth');
    dispatch({
      type: actionTypes.GET_CHAT_TOKEN_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: actionTypes.GET_CHAT_TOKEN_ERROR,
      payload: error,
    });
  }
};

export const setAssociateChatStatus = (newStatus) => ({
  type: actionTypes.SET_ASSOCIATE_CHAT_STATUS,
  payload: newStatus,
});

export const clearChatData = () => ({
  type: actionTypes.CLEAR_CHAT_INITIALIZATION_DATA,
});
